<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <mtc-form-item label="label.accountNumber">
              <!--<a-input placeholder="请输入账号查询" v-model="queryParam.username"></a-input>-->
              <j-input :placeholder="$t('label.pleaseEnterTheAccountNumber')" v-model="queryParam.username"></j-input>
            </mtc-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <mtc-form-item label="label.cellPhone">
              <a-input :placeholder="$t('label.pleaseEnterCellPhoneNumber')" v-model="queryParam.phone"></a-input>
            </mtc-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <BaseTable ref="baseTable"
               @searchReset="searchReset"
               @selectRow="onSelectChange"
               :mainTable="mainTable"
               :advancedSearch="false"
               :tableColumns="columns"
               :tableData="tableData">
      <template slot="avatarslot" slot-scope="{record}">
        <div class="anty-img-wrap">
          <a-avatar shape="square" :src="getAvatarView(record.avatar)" icon="user" />
        </div>
      </template>
      <span slot="action" slot-scope="{record}">
          <mtc-button @click="distributionTenant(record)" type="link" size="small" text="dynamic.distributionTenant" />
        </span>
    </BaseTable>
    <!-- 分配租户 -->
    <DistributionTenantModal ref="distributionTenantModal" @ok="submit"/>
  </a-card>
</template>

<script>
import { putAction, getFileAccessHttpUrl } from '@/api/manage'
import { frozenBatch, getUserList } from '@/api/api'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { MTC_AUTH } from '@api/servers'
import { BaseTable } from '@comp/mtcModule'
import DistributionTenantModal from '@views/system/modules/DistributionTenantModal'

export default {
  name: 'tenantUserList',
  title: '租户用户管理',
  mixins: [JeecgListMixin],
  components: { BaseTable, DistributionTenantModal },
  data() {
    return {
      mainTable: 'sys_user',
      // 列表数据
      tableData: params => this.getData(params),
      //查询条件收起状态
      toggleSearchStatus: true,
      queryParam: {},
      recycleBinVisible: false,
      columns: [
        /*{
          title: '#',
          dataIndex: '',
          key:'rowIndex',
          width:60,
          align:"center",
          customRender:function (t,r,index) {
            return parseInt(index)+1;
          }
        },*/
        {
          slotName: 'tableHeader.userAccount',
          // title: '用户账号',
          align: 'center',
          dataIndex: 'username',
          width: 120,
          sorter: true,
          scopedSlots: { title: 'tableHeader.userAccount' }
        },
        {
          slotName: 'tableHeader.userName',
          // title: '用户姓名',
          align: 'center',
          width: 100,
          dataIndex: 'realname',
          scopedSlots: { customRender: 'realname', title: 'tableHeader.userName' }
        },
        {
          slotName: 'tableHeader.image',
          // title: '头像',
          align: 'center',
          width: 120,
          dataIndex: 'avatar',
          scopedSlots: { customRender: 'avatarslot', title: 'tableHeader.image' }
        },
        {
          slotName: 'tableHeader.gender',
          // title: '性别',
          align: 'center',
          width: 80,
          dataIndex: 'sex_dictText',
          sorter: true,
          scopedSlots: { title: 'tableHeader.gender' }
        },
        {
          slotName: 'tableHeader.birthday',
          // title: '生日',
          align: 'center',
          width: 100,
          dataIndex: 'birthday',
          scopedSlots: { title: 'tableHeader.birthday' }
        },
        {
          slotName: 'tableHeader.cellPhone',
          // title: '手机号码',
          align: 'center',
          width: 100,
          dataIndex: 'mobile',
          scopedSlots: { title: 'tableHeader.cellPhone' }
        },
        // {
        //   title: '部门',
        //   align: "center",
        //   width: 180,
        //   dataIndex: 'orgCodeTxt'
        // },
        // {
        //   title: '负责部门',
        //   align: "center",
        //   width: 180,
        //   dataIndex: 'departIds_dictText'
        // },
        {
          slotName: 'tableHeader.status',
          // title: '状态',
          align: 'center',
          width: 80,
          dataIndex: 'status_dictText',
          scopedSlots: { title: 'tableHeader.status' }
        },
        {
          slotName: 'tableHeader.operation',
          // title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action', title: 'tableHeader.operation' },
          align: 'center',
          width: 80
        }
      ],
      superQueryFieldList: [
        { type: 'input', value: 'username', text: this.$t('label.userAccount') },
        { type: 'input', value: 'realname', text: this.$t('label.userName') },
        { type: 'select', value: 'sex', text: this.$t('label.gender'), dictCode: 'sex' }
      ],
      url: {
        syncUser: `${MTC_AUTH}act/process/extActProcess/doSyncUser`,
        list: `${MTC_AUTH}sys/user/list`,
        delete: `${MTC_AUTH}sys/user/delete`,
        deleteBatch: `${MTC_AUTH}sys/user/deleteBatch`,
        exportXlsUrl: `${MTC_AUTH}sys/user/exportXls`,
        importExcelUrl: `${MTC_AUTH}sys/user/importExcel`
      }
    }
  },
  computed: {
    importExcelUrl() {
      return `${window._CONFIG[ 'domianURL' ]}/${this.url.importExcelUrl}`
    }
  },
  methods: {
    // 分配用户
    distributionTenant(data) {
      this.$refs.distributionTenantModal.openModal(data)
    },
    // 重置查询条件
    searchReset() {
      this.queryParam = {}
      this.$refs.baseTable.refresh()
    },
    getData(baseParams) {
      let params = {
        ...baseParams,
        ...this.queryParam
      }
      return getUserList(params)
    },
    getAvatarView(avatar) {
      return getFileAccessHttpUrl(avatar)
    },
    // 分配租户提交
    submit() {

    },
  }
}
</script>

<style scoped lang="less">
@import "~@assets/less/common.less";
</style>